'use strict';
/* globals React, ReactDOM, classNames, $ */

var BreakView = React.createClass({

  render: function() {
    //var label = this.props.breakLabel;
    return (
      <li className="page-item disabled"><a className="page-link"><span>&hellip;</span></a></li>
    );
  }

});
BreakView;

var PageView = React.createClass({

  render: function() {
    var linkClassName = this.props.pageLinkClassName;
    var cssClassName = this.props.pageClassName;

    if (this.props.selected) {
      if (typeof(cssClassName) !== 'undefined') {
        cssClassName = cssClassName + ' ' + this.props.activeClassName;
      } else {
        cssClassName = this.props.activeClassName;
      }
    }

    return (
        <li className={cssClassName}>
            <a {...this.props} className={linkClassName}>
              {this.props.page}
            </a>
        </li>
    );
  }

});
PageView;

var PaginationBoxView = React.createClass({

  propTypes: {
    pageNum               : React.PropTypes.number.isRequired,
    pageRangeDisplayed    : React.PropTypes.number.isRequired,
    marginPagesDisplayed  : React.PropTypes.number.isRequired,
    previousLabel         : React.PropTypes.node,
    nextLabel             : React.PropTypes.node,
    breakLabel            : React.PropTypes.node,
    clickCallback         : React.PropTypes.func,
    initialSelected       : React.PropTypes.number,
    forceSelected         : React.PropTypes.number,
    containerClassName    : React.PropTypes.string,
    pageClassName         : React.PropTypes.string,
    pageLinkClassName     : React.PropTypes.string,
    activeClassName       : React.PropTypes.string,
    previousClassName     : React.PropTypes.string,
    nextClassName         : React.PropTypes.string,
    previousLinkClassName : React.PropTypes.string,
    nextLinkClassName     : React.PropTypes.string,
    disabledClassName     : React.PropTypes.string
  },

  getDefaultProps: function() {
    return {
      pageNum              : 10,
      pageRangeDisplayed   : 2,
      marginPagesDisplayed : 3,
      activeClassName      : 'selected',
      previousClassName    : 'previous',
      nextClassName        : 'next',
      previousLabel        : 'Previous',
      nextLabel            : 'Next',
      breakLabel           : '...',
      disabledClassName    : 'disabled'
    };
  },

  getInitialState: function() {
    return {
      selected: this.props.initialSelected ? this.props.initialSelected : this.props.forceSelected ? this.props.forceSelected : 0
    };
  },

  componentDidMount: function() {
    if (typeof(this.props.initialSelected) !== 'undefined') {
      this.callCallback(this.props.initialSelected);
    }
    $(ReactDOM.findDOMNode(this.refs.prevLink)).tooltip();
    $(ReactDOM.findDOMNode(this.refs.nextLink)).tooltip();
  },

  componentWillReceiveProps: function (nextProps) {
    if (typeof(nextProps.forceSelected) !== 'undefined' && this.props.forceSelected !== nextProps.forceSelected) {
      this.setState({ selected: nextProps.forceSelected });
    }
  },

  handlePreviousPage: function (evt) {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
    if (this.state.selected > 0) {
      this.handlePageSelected(this.state.selected - 1, evt);
    }
  },

  handleNextPage: function (evt) {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);
    if (this.state.selected < this.props.pageNum - 1) {
      this.handlePageSelected(this.state.selected + 1, evt);
    }
  },

  handlePageSelected: function (selected, evt) {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

    if (this.state.selected === selected) return;

    this.setState({ selected: selected });

    // Call the callback with the new selected item:
    this.callCallback(selected);
  },

  callCallback: function (selectedItem) {
    if (typeof(this.props.clickCallback) !== 'undefined' && typeof(this.props.clickCallback) === 'function') {
      this.props.clickCallback({ selected: selectedItem });
    }
  },

  pagination: function () {
    var items = {};
    var index;

    if (this.props.pageNum <= this.props.pageRangeDisplayed) {

      for (index = 0; index < this.props.pageNum; index++) {
        items['key' + index] = (<PageView
          onClick={this.handlePageSelected.bind(null, index)}
          selected={this.state.selected === index}
          pageClassName={this.props.pageClassName}
          pageLinkClassName={this.props.pageLinkClassName}
          activeClassName={this.props.activeClassName}
          page={index + 1} />);
      }

    } else {

      var leftSide  = (this.props.pageRangeDisplayed / 2);
      var rightSide = (this.props.pageRangeDisplayed - leftSide);

      if (this.state.selected > this.props.pageNum - this.props.pageRangeDisplayed / 2) {
        rightSide = this.props.pageNum - this.state.selected;
        leftSide  = this.props.pageRangeDisplayed - rightSide;
      }
      else if (this.state.selected < this.props.pageRangeDisplayed / 2) {
        leftSide  = this.state.selected;
        rightSide = this.props.pageRangeDisplayed - leftSide;
      }

      var page;
      var breakView;

      for (index = 0; index < this.props.pageNum; index++) {

        page = index + 1;

        var pageView = (
          <PageView
            onClick={this.handlePageSelected.bind(null, index)}
            selected={this.state.selected === index}
            pageClassName={this.props.pageClassName}
            pageLinkClassName={this.props.pageLinkClassName}
            activeClassName={this.props.activeClassName}
            page={index + 1} />
        );

        if (page <= this.props.marginPagesDisplayed) {
          items['key' + index] = pageView;
          continue;
        }

        if (page > this.props.pageNum - this.props.marginPagesDisplayed) {
          items['key' + index] = pageView;
          continue;
        }

        if ((index >= this.state.selected - leftSide) && (index <= this.state.selected + rightSide)) {
          items['key' + index] = pageView;
          continue;
        }

        var keys            = Object.keys(items);
        var breakLabelKey   = keys[keys.length - 1];
        var breakLabelValue = items[breakLabelKey];

        if (this.props.breakLabel && breakLabelValue !== breakView) {
          breakView = (
            <BreakView breakLabel={this.props.breakLabel} />
          );

          items['key' + index] = breakView;
        }
      }
    }

    return items;
  },

  render: function() {
    var disabled = this.props.disabledClassName;

    var previousClasses = classNames(this.props.previousClassName, {[disabled]: this.state.selected === 0});

    var nextClasses = classNames(this.props.nextClassName, {[disabled]: this.state.selected === this.props.pageNum - 1});

    return (
      <ul className={this.props.containerClassName}>
        <li onClick={this.handlePreviousPage} className={previousClasses}>
          <a className={this.props.previousLinkClassName} data-toggle="tooltip" data-placement="top" title="Page précédente [Ctrl+Alt+,]" ref="prevLink">{this.props.previousLabel}</a>
        </li>

        {React.addons.createFragment(this.pagination())}

        <li onClick={this.handleNextPage} className={nextClasses}>
          <a className={this.props.nextLinkClassName} data-toggle="tooltip" data-placement="top" title="Page suivate [Ctrl+Alt+.]" ref="nextLink">{this.props.nextLabel}</a>
        </li>
      </ul>
    );
  }

});
window.PaginationBoxView = PaginationBoxView;